"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewConstant = void 0;
class PreviewConstant {
}
exports.PreviewConstant = PreviewConstant;
PreviewConstant.webAppDefaultTitle = "Untitled";
PreviewConstant.webAppDefaultSubTitle = "Welcome! This is a generative AI web app built in Imagica. Give it a try!";
